import { render, staticRenderFns } from "./CascadingPermissionsProfilesEditModal.vue?vue&type=template&id=29631a38"
import script from "./CascadingPermissionsProfilesEditModal.vue?vue&type=script&lang=js"
export * from "./CascadingPermissionsProfilesEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports